import { render, staticRenderFns } from "./Fechas.vue?vue&type=template&id=61e80510&"
import script from "./Fechas.vue?vue&type=script&lang=js&"
export * from "./Fechas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports